import { useContext, useState } from 'react';
import StepHeader from '../../components/Wizard/StepHeader';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';
import Alert from '../../components/Alert';
import { SignUpContext } from '../../data/SignUp/SignUpContext';
import Date from '../../components/Date/Date';
import { useControllerFlowStepsContext } from '../../hooks/ControllerFlowStepsContext';
import RedirectSignIn from './RedirectSignIn';
import SignUpBirthdateInvalid from './SignUpBirthdateInvalid';
import { UNDER_AGE_ERROR_MESSAGE } from '../../data/Constants';

export interface SignUpBirthdateProps {
  allowSkipStep?: boolean;
  updateData?: boolean;
  previousPath?: number | null;
  nextPath?: number | null;
  handleChangeStep(e: number): void;
  context: any;
}

export default function SignUpBirthdate({
  nextPath,
  previousPath,
  handleChangeStep,
  context
}: SignUpBirthdateProps) {
  const [errorRequest, setErrorRequest] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isUnderAge, setIsUnderAge] = useState(false);

  const { providerSocial, socialData } = useControllerFlowStepsContext();
  const {
    register,
    trigger,
    errors,
    touchedFields,
    handleSubmit,
    submitForm,
    setValue,
    getValues
  } = useContext(SignUpContext);

  function controlBackPage() {
    if (previousPath == 0 || previousPath) handleChangeStep(previousPath);
  }

  window.onpopstate = () => {
    controlBackPage();
  };

  async function checkValidateFields() {
    const validateBirthDate = await trigger(['birthDate']);
    return new Promise((resolve) => resolve(validateBirthDate));
  }

  async function nextStep() {
    await checkValidateFields();

    if (errors?.birthDate?.message === UNDER_AGE_ERROR_MESSAGE) {
      setIsUnderAge(true);
      return;
    }

    if (!errors?.birthDate && nextPath) {
      setValue('isSocial', true);
      setValue('provider', providerSocial);
      if (socialData.email) setValue('email', socialData.email);
      setIsLoading(true);
      await handleSubmit(
        async (data: any) =>
          await submitForm(
            data,
            () => handleChangeStep(nextPath),
            providerSocial
          )
      )();
    }
  }

  if (isUnderAge) {
    return <SignUpBirthdateInvalid getValues={getValues} />;
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <StepHeader
          title="Pergunta básica"
          description="Precisamos saber sua idade para te proteger de conteúdos sensíveis."
        />

        <div className="form-group">
          <Alert
            message={errorRequest}
            errors={errors}
            onClose={setErrorRequest}
          />

          <Date
            register={register}
            errors={errors}
            touchedFields={touchedFields}
          />
        </div>
      </div>

      <div className="button-group">
        <Button
          id="signup-birthdate"
          full
          onClick={nextStep}
          disabled={
            (!!errors?.birthDate &&
              errors?.birthDate?.message !== UNDER_AGE_ERROR_MESSAGE) ||
            !touchedFields?.birthDate ||
            isLoading
          }
        >
          <ButtonLabel loading={isLoading}>continuar</ButtonLabel>
        </Button>
        <Button
          customColors="btn-ghost"
          aria-label="Voltar"
          onClick={controlBackPage}
          disabled={isLoading}
        >
          <ButtonLabel>Voltar</ButtonLabel>
        </Button>
        <RedirectSignIn context={context} />
      </div>
    </div>
  );
}
